import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import makeQueryKey from "../../../../../utils/make-query-key";

// TODO: make sure to clear this on logout bc queryKey doesn't have upmId

var getFetchIdentityUserAddressOptions = function getFetchIdentityUserAddressOptions() {
  return {
    queryKey: makeQueryKey(['identity/user/v1/address']),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _window, _window2;
        var _ref, upmId, token, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 || (_window = _window.identity) === null || _window === void 0 ? void 0 : _window.getUserProfile();
            case 1:
              _t = _context.sent;
              if (_t) {
                _context.next = 2;
                break;
              }
              _t = {};
            case 2:
              _ref = _t;
              upmId = _ref.upmId;
              _context.next = 3;
              return (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webShellClient) === null || _window2 === void 0 || (_window2 = _window2.identity) === null || _window2 === void 0 ? void 0 : _window2.getAccessToken();
            case 3:
              token = _context.sent;
              return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/identity/user/v1/").concat(upmId, "/address"), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  'x-nike-ux-id': DOTCOM_UX_ID,
                  Authorization: "Bearer ".concat(token)
                }
              }, 'Error fetching user data.', {
                pageActionName: 'tread-identity'
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }()
  };
};
export default getFetchIdentityUserAddressOptions;